module.exports = __webpack_public_path__ + "static/media/nav_logo.468a0818.png";